/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon16Light = forwardRef('MoneyCurrencyRubleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a1 1 0 0 0-1 1v5H3.5a.5.5 0 0 0 0 1H5v2H3.5a.5.5 0 0 0 0 1H5v1.75a.5.5 0 0 0 1 0V12h3.5a.5.5 0 0 0 0-1H6V9h3.5a3.5 3.5 0 1 0 0-7H6Zm3.5 6H6V3h3.5a2.5 2.5 0 0 1 0 5Z" })));
});
